import React from "react"
import { Box, Checkbox, CircularProgress, IconButton, Tooltip, Typography } from "@mui/material"
import { Close, Download } from "@mui/icons-material"

interface Props {
  totalCount: number
  selectedCount: number
  downloading: boolean
  generatingVideo: boolean
  canGenerateVideo: boolean
  onSelectAll: () => void
  onClearAll: () => void
  onDownloadZip: () => void
  onGenerateVideo: () => void
}

const GalleryToolbar: React.FC<Props> = ({
  totalCount,
  selectedCount,
  downloading,
  generatingVideo,
  canGenerateVideo,
  onSelectAll,
  onClearAll,
  onDownloadZip,
  onGenerateVideo
}) => {
  const hasSelection = selectedCount > 0
  const allSelected = totalCount > 0 && selectedCount === totalCount

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        py: 2,
        px: { xs: 2, sm: 3 },
        flexWrap: "wrap"
      }}>
      <Typography variant="h5" fontWeight={600} sx={{ flex: 1, minWidth: 120 }}>
        {hasSelection ? `${selectedCount} selected` : "Photos"}
      </Typography>

      {!hasSelection && (
        <Typography variant="body2" color="text.secondary">
          {totalCount} {totalCount === 1 ? "photo" : "photos"}
        </Typography>
      )}

      {hasSelection && (
        <>
          <Tooltip title={allSelected ? "Deselect all" : `Select all (${totalCount})`}>
            <Checkbox
              checked={allSelected}
              indeterminate={!allSelected}
              onChange={() => (allSelected ? onClearAll() : onSelectAll())}
              aria-label="select all"
              size="small"
            />
          </Tooltip>
          <Tooltip title="Cancel selection">
            <IconButton onClick={onClearAll} aria-label="cancel selection">
              <Close />
            </IconButton>
          </Tooltip>
          <Tooltip title={downloading ? "Preparing…" : `Download ZIP (${selectedCount})`}>
            <span>
              <IconButton color="primary" onClick={onDownloadZip} disabled={downloading} aria-label="download zip">
                {downloading ? <CircularProgress size={20} color="inherit" /> : <Download />}
              </IconButton>
            </span>
          </Tooltip>
        </>
      )}
    </Box>
  )
}

export default GalleryToolbar
